import React from "react";
import SessionExpiredModal from "../components/Modal/SessionExpired";

const SessionExpired = (_props) => {
    return <SessionExpiredModal show="true" />;
};

export default SessionExpired;
